import { getSanitizedRgbaClassName } from '../utils';

export const referenceModelClassName = (modelId: string) => `m${modelId}`;
export const referenceTypeClassName = (referenceTypeId: string | number) =>
  `nr${referenceTypeId}`;
export const filterClass = (filterColor: string) =>
  filterColor.startsWith('#')
    ? filterColor.replace('#', 'filter')
    : filterColor.toLowerCase().startsWith('rgba')
      ? getSanitizedRgbaClassName(filterColor)
      : undefined;
